import React from 'react';
import { Action, ICON_EYE_OUTLINE } from '@doveit/bricks';
import { BrandTemplate } from '../../../providers/api/dtos';
import CanvaCard from '../canva-card/CanvaCard';
import { goToPage } from '../../../utils/navigate/utils';
import useBrandTemplate from '../../hooks/use-brand-template/useBrandTemplate';
import CanvaCardSkeleton from '../canva-card/CanvaCard.skeleton';
import { buildCanvaFillPath } from '../../utils/autofill/utils';
import { BrandTemplateAutofillParams } from '../../types';

type WithBrandTemplate = {
  brandTemplate: BrandTemplate,
  brandTemplateId?: never
};

type WithBrandTemplateId = {
  brandTemplateId: BrandTemplate['id'],
  brandTemplate?: never
};

export type CanvaModelCardProps = (WithBrandTemplate | WithBrandTemplateId) & {
  autofillParams?: BrandTemplateAutofillParams,
};

/**
 * @todo Rename to ViewCanvaBrandTemplateCard and move it under containers
 */
const CanvaModelCard: React.FC<CanvaModelCardProps> = ({
  brandTemplate: externalBrandTemplate,
  brandTemplateId,
  autofillParams,
}) => {
  const {
    data: fetchedBrandTemplate,
    isLoading: isBrandTemplateLoading,
    error: brandTemplateError,
  } = useBrandTemplate(brandTemplateId);

  const brandTemplate = externalBrandTemplate || fetchedBrandTemplate;

  const handleView = React.useCallback(() => {
    if (!brandTemplate) return;

    goToPage(brandTemplate.viewUrl);
  }, [brandTemplate]);

  const handleCreateDesign = React.useCallback(() => {
    if (!brandTemplate) return;

    goToPage(buildCanvaFillPath(brandTemplate.id, autofillParams));
  }, [autofillParams, brandTemplate]);

  if (isBrandTemplateLoading) {
    return <CanvaCardSkeleton type="template" />;
  }

  if (!brandTemplate || brandTemplateError) {
    return null;
  }

  return (
    <CanvaCard
      title={brandTemplate.title}
      date={brandTemplate.createdAt}
      dateLabel="Creato il"
      type="template"
      thumbnailUrl={brandTemplate.thumbnail?.url}
      primaryAction={(
        <Action
          label="Usa template"
          size="S"
          onClick={handleCreateDesign}
        />
      )}
      secondaryAction={{ icon: { path: ICON_EYE_OUTLINE }, label: 'Visualizza template', onClick: handleView }}
    />
  );
};

export default CanvaModelCard;
